import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

interface IPatientNewMedicalNoteWarningPopupProps {
    SummaryModel: IPatientMedicalSummaryModel;
}

class NewMedicalNoteWarningPopup extends React.Component<IPatientNewMedicalNoteWarningPopupProps, any> {
    private id: string = "newmedicalnotewarningpopup";

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        let encounterDate = this.props.SummaryModel.get("NewNoteWarningEncounterDate");
        let title = cacheStore.GetString("AddNewNoteLabel");

        let buttonsDisabled = this.props.SummaryModel.get("NewNoteWarningEncounterId") == "";

        let msg = cacheStore.GetString("NewNoteWarningLabel", { date: moment(encounterDate).format("YYYY-MM-DD") });
        return (
            <Popup
                Id={this.id}
                title={title}
                closeTarget={LocalPatientOperations.MedicalSummary.NewNoteWarningCancel}
                draggable={true}
                centeredHorizontally={true}
            >
                <div className="p-body">
                    {msg.split("\n").map((val, i) => (
                        <div key={i}>
                            <span>{val}</span>
                        </div>
                    ))}
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button
                                        data-action="cancel"
                                        className="btn btn-default push-right-5"
                                        onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalSummary.NewNoteWarningCancel)}
                                    >
                                        {cacheStore.GetString("CancelLabel")}
                                    </button>
                                    <button
                                        className="btn btn-default push-right-5"
                                        disabled={buttonsDisabled}
                                        onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalSummary.NewNoteWarningContinueNote)}
                                    >
                                        {cacheStore.GetString("ContinueNoteLabel")}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        data-cy="medical-note-popup-start-new-note"
                                        disabled={buttonsDisabled}
                                        onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalSummary.NewNoteWarningStartNewNote)}
                                    >
                                        {cacheStore.GetString("StartNewNoteLabel")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export { IPatientNewMedicalNoteWarningPopupProps, NewMedicalNoteWarningPopup };
